import { track, usePageAnalytics } from '@/features/analytics';
import { useLanguage } from '@/features/i18n';
import LandingFooter from '../landing/LandingFooter';
import LandingHeader from '../landing/LandingHeader';
import LandingHeroSection from '../landing/LandingHeroSection';
import PracticeWorkflow from '../landing/PracticeWorkflow';
import {
  getDemoPath,
  getLandingContent,
} from '../landing/landingContent';

import '../../../styles/landing.css';

export default function LandingHero() {
  const { language } = useLanguage();
  const content = getLandingContent(language);
  const demoPath = getDemoPath(language);
  const landingPath = `/${content.locale}`;
  usePageAnalytics('landing', { properties: { landing_path: landingPath } });

  const trackDemo = () => {
    track('landing_demo_click', { placement: 'hero', landing_path: landingPath }, 'landing');
  };
  const trackLogin = () => {
    track('landing_login_click', { placement: 'header', landing_path: landingPath }, 'landing');
  };

  return (
    <>
      <LandingHeader
        language={content.locale}
        brand={content.brand}
        nav={content.nav}
        onLoginClick={trackLogin}
      />
      <main className="landing-page" data-route="landing">
        <LandingHeroSection
          hero={content.hero}
          disclosure={content.demoDisclosure}
          demoPath={demoPath}
          onDemoClick={trackDemo}
        />
        <PracticeWorkflow
          label={content.nav.workflow}
          items={content.workflow}
        />
      </main>
      <LandingFooter
        language={content.locale}
        footer={content.footer}
        guideLabel={content.nav.guides}
        guidePath={content.guideHubPath}
      />
    </>
  );
}
